"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PRODUCT_PATH = "/produkt";
exports.CART_PATH = "/handlekurv";
exports.CHECKOUT_PATH = "/utsjekk";
exports.BOOKING_PATH = "/booking";
exports.LOGIN_PATH = "/logg-inn";
exports.NO_ACCESS_PATH = "/ingen-tilgang";
exports.MY_PAGE_PATH = "/min-side";
exports.RESET_PASSWORD_PATH = exports.LOGIN_PATH + "/nytt-passord";
exports.CART_COOKIE_NAME = "cart";
exports.CART_COOKIE_ID_NAME = "cart_id";
exports.STOREFRONT_ENDPOINT = "api/v1/storefront";
exports.ADMIN_ENDPOINT = "api/v1/admin";
exports.PLACEHOLDER_TRIGGER_EVENT = "placeholder-trigger";
exports.PLACEHOLDER_IMAGE = {
    ref: "placeholder",
    url: "https://res.cloudinary.com/oyvindhermansen/image/upload/v1561016972/empty_preview.png",
    alt: "Bilde mangler",
    lazyLoad: true,
    focus: {},
};
//# sourceMappingURL=constants.js.map